import React from 'react';
import { Badge } from '../ui/badge';

const STATUS_STYLES = {
  active: 'bg-green-600',
  trial: 'bg-blue-600',
  expired: 'bg-red-600',
  cancelled: 'bg-slate-500',
  pending: 'bg-amber-600',
  none: 'bg-muted text-muted-foreground',
};

export default function SubscriptionStatusBadge({ status }) {
  const key = status || 'none';
  const label = key === 'none' ? 'No plan' : key.charAt(0).toUpperCase() + key.slice(1);
  return (
    <Badge className={`${STATUS_STYLES[key] || STATUS_STYLES.none} text-white`}>
      {label}
    </Badge>
  );
}
